export interface IVolumeTrend {
    [date: string]: number;
}

interface IKeywordIdeasRecord {
    keyword: string;
    monthlyVolume: number;
    prevVolume: number;
    volumeChangeState: string;
    volumeChangePresentation: string;
    clicks: number;
    cpc: number;
    leadingSite: string;
    difficulty: number;
    latestZeroClicks: number;
    primaryIntent: string;
    secondaryIntent: string;
    volumeTrend: IVolumeTrend;
    averageVolume: number;
    favicon: string;
    volume?: number;
    volumeChange?: number;
    windowVolume?: number;
}

export interface IKeywordIdeasResponseData {
    records: IKeywordIdeasRecord[];
}

interface IVolumeChange {
    first: number | undefined;
    last: number | undefined;
    change: number | undefined;
    changeState: string | undefined;
}

interface ITransformedKeywordIdeasRecord extends IKeywordIdeasRecord {
    SearchTerm: string;
    url: string;
    country: string;
    countryName: string;
    durationText: string;
    web_source: string;
    intents: {
        PrimaryIntent: string;
        SecondaryIntent: string;
    };
    VolumeChange?: IVolumeChange;
}

export interface ITransformedKeywordIdeasData {
    records: ITransformedKeywordIdeasRecord[];
}

export enum EKeywordIdeasTabs {
    RELATED,
    TRENDING,
    QUESTIONS,
}

export enum ETabIndexToTabName {
    relatedKeywords,
    trending,
    questions,
}
